import React, { Component } from 'react';
import Header from '../components/Principal/Header';
import Footer from '../components/Principal/Footer';
import Seccion1 from '../components/Canales_Atencion/Seccion1';
import Seccion2 from '../components/Canales_Atencion/Seccion2';
// import Seccion3 from '../components/Asociados/Seccion3';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';

class CanalesAtencion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadpage: false
        };
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({
                loadpage: true
            })
        }, 0.1)
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <MensajeF />
                {this.state.loadpage ? (
                    <div>
                        <Seccion1 />
                        <Seccion2 />
                        {/* <Seccion3 /> */}
                    </div>
                ) : (<React.Fragment></React.Fragment>)}
                <Footer />
            </React.Fragment>
        );
    }
}

export default CanalesAtencion;